import React from "react";
import {observer} from "mobx-react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {Button} from "../../../../basic-ui-components/button/base/button.component";
import {CyClass} from "../../../../../common/cy-classes";
import {getButtonSizeVariant} from "../../welcome-buttons/header-welcome-buttons-helpers";
import {HeaderWelcomeButtonsAnalyticsSender} from "../../welcome-buttons/header-welcome-buttons-analytics-sender";
import {HeaderWelcomeLoginButtonComponentProps} from "./header-login-button.component.props";
import {ComponentServicesPick} from "../../../../services/component-services-pick";
import {withServices} from "../../../../react-hooks/with-services";

interface HeaderLoginButtonComponentWithServiceProps extends  HeaderWelcomeLoginButtonComponentProps, ComponentServicesPick<'header'> {
}


@observer
export class ComponentBody extends OrbitComponent<HeaderLoginButtonComponentWithServiceProps> {

    private _onClick = async () => {
        if(this.services.regulation.shouldEnforceHybridAppForMobileWeb()) {
            new HeaderWelcomeButtonsAnalyticsSender('DownloadApp', this.services, this.props.gameContext).sendAnalytics();
            this.services.specificDialogs.enforceHybridAppModal();
        } else {
            new HeaderWelcomeButtonsAnalyticsSender('login', this.services, this.props.gameContext).sendAnalytics();
            await this.services.user.openLogin({
                dl: "19519"
            });
        }
    }


    render() {

        return (
            <Button
                preset={this.props.preset ?? "secondary"}
                sizeVariant={getButtonSizeVariant(this.services)}
                onClick={this._onClick}
                className={CyClass("cy-login-button-text")}
                skeleton={this.props.header.skeleton}
            >
                { this.services.translation.translate("Login") }
            </Button>
        )
    }
}
export const HeaderLoginButtonComponent = withServices(ComponentBody, ["header"]);